// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".recent_leads[data-v-801cbd70]{min-height:80px;position:relative}", "",{"version":3,"sources":["webpack://./resources/client/layouts/page/components/RecentLeadsModal.vue"],"names":[],"mappings":"AACA,+BAEE,eAAA,CADA,iBACF","sourcesContent":["\n.recent_leads {\n  position: relative;\n  min-height: 80px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
